module.exports = "img/8.d31c54.webp";